var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pointer",on:{"click":function($event){$event.stopPropagation();return _vm.openWhatsApp.apply(null, arguments)}}},[_c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('v-icon',{attrs:{"color":hover ? 'primary' : 'lightText'}},[_vm._v("mdi-whatsapp")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }